import { Component, OnInit, ViewChild } from '@angular/core';
import { RomaneioService } from '../service/romaneio.service';
import { PedidoService } from 'src/app/faturamento/service/pedido.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoTableColumn } from '@po-ui/ng-components';
import { getPedidoDefault, PedidoDto, TipoCliente, TipoFrete, TipoPedido } from 'src/app/faturamento/interface/pedido';

@Component({
  selector: 'app-estoque-romaneio-liberacao-pedido',
  templateUrl: './estoque-romaneio-liberacao-pedido.component.html',
  styleUrl: './estoque-romaneio-liberacao-pedido.component.css'
})
export class EstoqueRomaneioLiberacaoPedidoComponent implements OnInit {

  tipoRomaneio: string = '';
  codigoRomaneio: string = '';
  codigoPedido: string = '';
  disableIndices: boolean = true;

  pedido: PedidoDto;

  constructor(
    private romaneioService: RomaneioService,
    private pedidoService: PedidoService,
    private route: ActivatedRoute,
    private poDialogService: PoDialogService,
    private router: Router,
    private poNotificationService: PoNotificationService,
  ) {
    this.pedido = getPedidoDefault();
  }

  @ViewChild( 'modalLiberacao' , { static: true }) modalLiberacao!: PoModalComponent;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.codigoRomaneio = params['CZ00COD'];
      this.codigoPedido = params['CC5NUM'];
      this.tipoRomaneio = params['CTIPO'];

      this.pedidoService.getPedido(this.codigoPedido).subscribe(pedido => {
        this.pedido = {...getPedidoDefault(), ...pedido, NVALORALIBERAR: 0, NVALORTOTAL: 0};
        this.pedido.items = this.pedido.items.map((item) => {
          this.pedido.NVALORALIBERAR += (item.NC6QTDVEN - item.NC6QTDLIB) * item.NC6PRCVEN;
          this.pedido.NVALORTOTAL += item.NC6VALOR;
          if (item.CB1XFAM == "035") {
            this.disableIndices = false;
            this.pedido.CTEMP40 = "0";
            this.pedido.CTEOR1 = "0";
          }
          return {...item, NQTDLIBERAR: item.NC6QTDVEN - item.NC6QTDLIB, NVALLIBERAR: (item.NC6QTDVEN - item.NC6QTDLIB) * item.NC6PRCVEN};
        });

        this.romaneioService.getObjectByValue(this.codigoRomaneio).subscribe((res)=> {
          if(res.CZ00MENNOT) {
            this.pedido.CC5MENNOTA  = res.CZ00MENNOT;
          }
        });
      });
    });
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Início', action: this.goTo.bind(this) },
      { label: 'Romaneio', action: this.goToRomaneio.bind(this) },
      { label: 'Liberar Pedido' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToRomaneio(): void {
    if (this.tipoRomaneio == 'MI') {
      this.router.navigateByUrl(`/estoque/expedicao/romaneio-mi/cadastro/${this.codigoRomaneio}`);
    } else {
      this.router.navigateByUrl(`/estoque/expedicao/romaneio-cliente/cadastro/${this.codigoRomaneio}`);
    }
  }

  public readonly actions: Array<PoPageAction> = [
    { label: 'Liberar', action: this.liberarAction.bind(this)},
  ];

  liberarAction(): void {
    this.modalLiberacao.open();
  }

  public readonly modalLiberarAction: PoModalAction = {
    action: () => {
      this.liberar();
    },
    label: 'Liberar pedido'
  };

  liberar(): void {
    this.romaneioService.liberarPedidos(this.pedido, this.codigoRomaneio).subscribe((ret) => {
      this.modalLiberacao.close();
      this.poNotificationService.success("Pedido liberado com sucesso!");
      this.goToRomaneio();
    });
  }

  getTipoPedidoDescricao(): string {
    return (TipoPedido as any)[this.pedido.CC5TIPO];
  }

  getTipoFreteDescricao(): string {
    return (TipoFrete as any)[this.pedido.CC5TPFRETE];
  }

  getTipoClienteDescricao(): string {
    return (TipoCliente as any)[this.pedido.CC5TIPOCLI];
  }

  public readonly colunas: Array<PoTableColumn> = [
    { property: 'CC6ITEM',    visible: true,  label: 'Item'           },
    { property: 'CC6PRODUTO', visible: true,  label: 'Produto'        },
    { property: 'CC6DESCRI',  visible: true,  label: 'Descrição'      },
    { property: 'CC6UM',      visible: true,  label: 'UM'             },
    { property: 'NC6QTDVEN',  visible: true,  label: 'Qtd Venda'      },
    { property: 'NC6QTDLIB',  visible: true,  label: 'Qtd Liberada'   },
    { property: 'NQTDLIBERAR',visible: true,  label: 'Qtd a Liberar'  },
    { property: 'NC6QTDENT',  visible: true,  label: 'Qtd Entregue'   },
    { property: 'NC6PRCVEN',  visible: true,  label: 'Preço Unit.',     type: 'currency', format: 'BRL' },
    { property: 'NVALLIBERAR',visible: true,  label: 'Valor a Liberar', type: 'currency', format: 'BRL' },
    { property: 'NC6VALOR',   visible: true,  label: 'Valor Total',     type: 'currency', format: 'BRL' },
    { property: 'CC6TES',     visible: false, label: 'TES'            },
    { property: 'CC6SEGUM',   visible: false, label: 'UM 2'           },
    { property: 'NC6UNSVEN',  visible: false, label: 'Qtd Venda 2'    },
    { property: 'NC6QTDLIB2', visible: false, label: 'Qtd Lib'        },
    { property: 'NC6QTDENT2', visible: false, label: 'Qtd Entregue 2' },
    { property: 'CC6LOCAL',   visible: false, label: 'Local'          },
  ];

}
